// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__h2427","left":"About_left__DWbB7","right":"About_right__2P-qt","data":"About_data__BEaHd"};